var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"class-layout":"with_search"}},[_c('b-row',{attrs:{"align-v":"start"}},[_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('Search')],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"4"}})],1)],1),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }